import { useI18n} from "vue-i18n"

export const organisations: TableModule = {
    name: "organisations",
    route: "spa.settings.organisations",
    columns: [
        {
            name: "id",
            sortable: true,
            width: "w-[75px]",
            breakpoint: "xl"
        }, {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        }, {
            name: "city",
            sortable: true,
            breakpoint: "xl",
            width: "w-1/12"
        },{
            name: "type",
            sortable: true,
            breakpoint: "xl"
        }, {
            name: "active",
            width: "w-[60px]",
            breakpoint: "lg"
        }, {
            name: "transfer_agreement_accepted_at",
            width: "w-[155px]",
            breakpoint: "lg"
        }, {
            name: "categories",
        }, {
            name: "last_active_at",
            width: "w-[150px]"
        }
    ],
    filters: [
        {
            name: "active",
            column: "organisations.active",
            type: "boolean"
        }, {
            name: "customFilterTransferAgreement",
            column: "customFilterTransferAgreement",
            type: "boolean"
        }, {
            name: 'parent_organisation_id',
            column: 'organisations.parent_organisation_id',
            type: 'searchSelect',
            reduced: 'in',
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
            apiRoute: 'spa.settings.organisations.index',
        }, {
            name: 'category', // If changed or removed, also update onMounted in OrganisationTable.vue
            column: 'categories.id',
            relation: 'categories',
            type: 'searchSelect',
            reduced: 'in',
            apiRoute: 'spa.basedata.categories.index',
        }, {
            name: 'type',
            column: 'organisations.type',
            type: 'select',
            options: [
                {
                    value: 'organisation',
                    label: 'organisations.form.general.types.organisation'
                }, {
                    value: 'association',
                    label: 'organisations.form.general.types.association'
                }, {
                    value: 'rp',
                    label: 'organisations.form.general.types.rp'
                }
            ],
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        }, {
            name: "organisations.toggle",
            color: "rose"
        }, {
            name: "organisations.attachCategory",
        }, {
            name: "general.export",
            ability: ["create", "organisations"]
        }
    ]
}
